// Types
import type { ReactNode } from 'react';

import clsx from 'clsx';

type StickyFooterProps = {
    wrapperClassName?: string;
    children: ReactNode;
};

const StickyFooter = ({ wrapperClassName, children }: StickyFooterProps) => {
    return (
        <div className="sticky bottom-0 left-8 z-20 w-full">
            <div className="absolute -left-32 top-0 z-0 h-full w-[calc(100%+9.5rem)] border-t border-icoGray-300 bg-white xs:w-[calc(100%+10.5rem)] md:w-[calc(100%+13rem)] lg:w-[calc(100%+16rem)]" />
            <div className={clsx('relative z-1 flex w-full items-center py-3', wrapperClassName)}>
                {children}
            </div>
        </div>
    );
};

export default StickyFooter;
